export const RouterMap = [
    {
        path: '/',
        profile: 'Municipal Profile'
    },
    {
        path: '/populationforecast',
        profile: 'Population Forecasts'
    },
    {
        path: '/economicprofile',
        profile: 'Economic Profile'
    },
    {
        path: '/economicmodel',
        profile: 'Economic Model'
    },
    {
        path: '/economicmodeldashboard',
        profile: 'Economic Model'
    }
]

export const getRoute = (path) => {
    const match =  RouterMap.filter(item => {
        return item.path == path
    })
    return match.length > 0 ? match[0].profile : ''
}


// WEBPACK FOOTER //
// ./src/routers/RouterMap.js